export enum JobWorkRequestType {
  NOP = 0,
  ReconcileHolidayPreSettlement = 2,
  CreateDisputeFedEx = 3,
  SendPayrollDraft = 4,
  SendPayroll = 5,
  SendExceptionReport = 6,
  SendSettlementFiles = 7,
  SendTruckReport = 8,
  Revert = 10,
  MailFedExDirectory = 13,
  FedExDelayed = 14,
  ObjectChange = 16,
  WeeklySettlementSnapshot = 17,
  Test = 19,
  /* Reports */
  CreateSummaryData = 18,
  CreateSummaryDataPreEbo = 29,
  /* FedEx */
  DownloadAndImportFedEx = 15,
  ImportFedExDirectory = 12,
  ImportFile = 34,
  ReconcilePreMatch = 11,
  ReconcilePostMatch = 35,
  ReconcilePreEbo = 28, // Reconciles old/on-boarded entries Tenant ID & Service ID
  //AssignUnassigned = 1, //Unassigned Alias assignment

  /* Generate Payroll and Reports */
  PayrollProcess = 30,
  BuildReports = 31,
  SendReports = 32,
  LocationProcess = 37,
  OnBoardingProcess = 38,
  ScheduleNotifications = 39,
  CreateInvoices = 40,

  /* Third Party Integrations */
  IdelicExport = 20,
  RyderImport = 21,

  /* 
        Service Based Actions
        - Requires Action Service to be in the request
    */
  GetExternalInformation = 33,
  SubmitExternalInformation = 100,
  HOSDownload = 22,
  LocationDownload = 36,
  SyncSnapshot = 23, // Using snapshot ID
  SyncDelete = 24, // Using Snapshot ID
  SyncTenant = 25, // Using Tenant ID, provide Credential ID in Object ID if limit to one credential
  SyncObject = 26, // Using Object Type & ID

  //* Maintenance Tasks
  DbMaintenance = 27,

  //Driver Based Notifications 50-60
  SendDriverLogs = 50,
  SendMessage = 51,

  //Fuel Tasks
  CreateIvmrEmails = 52,
  CreateIvmrFiles = 53,
  SendCredentialReminders = 54,

  //Cross Tenant Requests
  EndOfYear = 1000
}

export const JobWorkRequestTypeMapping: Record<JobWorkRequestType, string> = {
  [JobWorkRequestType.NOP]: 'Do Nothing',
  [JobWorkRequestType.ReconcileHolidayPreSettlement]: 'Reconcile Holiday PreSettlement',
  [JobWorkRequestType.CreateDisputeFedEx]: 'Create Fedex Disputes',
  [JobWorkRequestType.SendPayrollDraft]: 'Send Payroll Draft',
  [JobWorkRequestType.SendPayroll]: 'SendPayroll',
  [JobWorkRequestType.SendExceptionReport]: 'Send Exception Report',
  [JobWorkRequestType.SendSettlementFiles]: 'SendSettlementFiles',
  [JobWorkRequestType.SendTruckReport]: 'Publishing Truck Report',
  [JobWorkRequestType.Revert]: 'Revert',
  [JobWorkRequestType.MailFedExDirectory]: 'MailFedExDirectory',
  [JobWorkRequestType.FedExDelayed]: 'FedExDelayed',
  [JobWorkRequestType.ObjectChange]: 'Item change',
  [JobWorkRequestType.WeeklySettlementSnapshot]: 'WeeklySettlementSnapshot',
  [JobWorkRequestType.Test]: 'Test',
  [JobWorkRequestType.CreateSummaryData]: 'Create Summary Data',
  [JobWorkRequestType.CreateSummaryDataPreEbo]: 'CreateSummaryDataPreEbo',
  [JobWorkRequestType.DownloadAndImportFedEx]: 'Download & Import FedEx',
  [JobWorkRequestType.ImportFedExDirectory]: 'Importing FedEx',
  [JobWorkRequestType.ImportFile]: 'Importing File',
  [JobWorkRequestType.ReconcilePreMatch]: 'Reconcile Pre-Match',
  [JobWorkRequestType.ReconcilePostMatch]: 'Reconcile Post-Match',
  [JobWorkRequestType.ReconcilePreEbo]: 'ReconcilePreEbo',
  //[JobWorkRequestType.AssignUnassigned]: 'AssignUnassigned',
  [JobWorkRequestType.IdelicExport]: 'IdelicExport',
  [JobWorkRequestType.RyderImport]: 'RyderImport',
  [JobWorkRequestType.HOSDownload]: 'HOSDownload',
  [JobWorkRequestType.SyncSnapshot]: 'SyncSnapshot',
  [JobWorkRequestType.SyncDelete]: 'SyncDelete',
  [JobWorkRequestType.SyncTenant]: 'SyncTenant',
  [JobWorkRequestType.SyncObject]: 'Item Sync',
  [JobWorkRequestType.DbMaintenance]: 'ArchiveChangeLog',
  [JobWorkRequestType.PayrollProcess]: 'Process Payroll',
  [JobWorkRequestType.BuildReports]: 'Build Reports',
  [JobWorkRequestType.SendReports]: 'Send Reports',
  [JobWorkRequestType.GetExternalInformation]: 'Get Information',
  [JobWorkRequestType.LocationDownload]: 'Download Location Data',
  [JobWorkRequestType.LocationProcess]: 'Processing Locations',
  [JobWorkRequestType.OnBoardingProcess]: 'OnBoarding Process',
  [JobWorkRequestType.ScheduleNotifications]: 'Schedule Notifications',
  [JobWorkRequestType.CreateInvoices]: 'Create Invoices',
  [JobWorkRequestType.SubmitExternalInformation]: 'Submit Information',
  [JobWorkRequestType.SendDriverLogs]: 'Send Driver Logs',
  [JobWorkRequestType.SendMessage]: 'Send Message',
  [JobWorkRequestType.EndOfYear]: 'Sending End Of Year',
  [JobWorkRequestType.CreateIvmrEmails]: 'Create IVMR Emails',
  [JobWorkRequestType.CreateIvmrFiles]: 'Create IVMR Files',
  [JobWorkRequestType.SendCredentialReminders]: 'Sending Credential Reminders'
};
